import React from "react";
import { Title, ItemsContainer, Item } from "../../CommonStyles";
import Row from "../../../Shared/Kit/Row";

const itemConfig = [
  "20 درصد پیش پرداخت خرید زمین پراخت گردیده است.",
  "بروزرسانی مجوز ساخت (پروانه ساختمان) در تعهد فروشنده بوده که در حال پیگیری است و در نتیجه متراژ زیربنای قابل ساخت و تعداد واحد ها و بلوک ها بروزرسانی خواهد شد.",
  "اخذ سند تک برگ قطعات در تعهد فروشنده بوده که در حال پیگیری می باشد.",
  "با شرکت مهندسین مشاور واجد صلاحیت برای تعیین نسبت مشارکت با اشخاص سرمایه گذار (خارج از مشارکت کنندگان) برای تامین منابع مالی اجرا قرارداد منعقد و  در حال انجام می باشد.",
  "برای تعیین نوع اسکلت ساختمان و بررسی معماری و تاسیسات مکانیکی و الکتریکال با مشاور قرارداد منعقد و مشاور در حال بررسی و محاسبات فنی و مالی که کدام نوع اسکلت توجیه فنی و اقتصادی دارد در حال انجام میباشد.",
  "آزمایشات ژئوتکنیک و خاک در حال به روزرسانی میباشد.",
  "با توجه به پیشنهادهای ارائه شده برای مشارکت، قطعات زمین خریداری شده به هیات کارشناسان رسمی دادگستری برای ارزیابی ارجاع شده است.",
];

const Section3 = () => {
  return (
    <>
      <Title>کار ها و فعالیت های انجام شده</Title>
      <ItemsContainer className="p-r">
        {itemConfig.map((each, index) => {
          return (
            <Item key={index}>
              <Row className="description">
                {index + 1}. &nbsp;
                {each}
              </Row>
            </Item>
          );
        })}
      </ItemsContainer>
    </>
  );
};

export default Section3;
